<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Client</mat-label>
      <input matInput formControlName="name" type="text" placeholder="Client" />
      <button
        type="button"
        *ngIf="form.get('name').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('name').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>OIDC audience</mat-label>
      <input matInput formControlName="oidcAudience" type="text" placeholder="OIDC audience" />
      <button
        type="button"
        *ngIf="form.get('oidcAudience').value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.get('oidcAudience').setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
